var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSetzling = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.25 136.53",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6e9530;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 128.53,
    width: 158.25,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.12,132.53h-8v-49.51l.43-.85c.26-.52,6.54-12.69,17.91-13.9,7.64-.82,15.28,3.43,22.72,12.61l-6.22,5.04c-5.61-6.93-10.87-10.19-15.63-9.7-5.8.6-9.92,6.64-11.22,8.81v47.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.75,87.6l-6.52-4.64c7.35-10.34,14.92-15.22,22.51-14.53,10.91,1,16.76,13.33,17.01,13.86l-7.25,3.37,3.63-1.69-3.62,1.7c-1.14-2.42-5.26-8.81-10.51-9.27-4.48-.4-9.75,3.48-15.24,11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.15,113.84l-2.14-6.59c-5.98-18.42-1.19-29.56,2.2-34.57,3.57-5.27,8.88-8.62,14.22-8.98l.53,7.98c-2.89.19-5.93,2.24-8.12,5.48-2.26,3.34-5.3,10.43-2.64,22.43,2.45-1.19,5.28-2.17,8.19-3.18,5.62-1.95,12.62-4.37,12.43-7.44l7.99-.49c.55,9.12-9.62,12.65-17.8,15.48-4.07,1.41-8.68,3.01-10.22,4.71l-4.64,5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.53,110.12l-5.35-4.79c-5.98-5.35-11.62-6.16-16.58-6.86-5.78-.82-12.33-1.76-14.14-10.83l7.84-1.57c.66,3.28,1.64,3.65,7.43,4.48,4.12.59,9.37,1.34,15.03,4.62.92-11.04-1.28-19.69-6.29-24.24-3.34-3.03-7.69-4-12.25-2.72l-2.15-7.71c7.2-2.01,14.41-.37,19.77,4.5,4.72,4.28,12.03,14.92,7.94,38.04l-1.25,7.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.38,63.92l-2.64-7.55c2.53-.88,3.7-3.19,4.25-4.97,1.33-4.36.36-10.11-2.31-13.67-4.31-5.77-7.83-12.44-10.23-17.56-2.66,5.26-6.46,12.3-10.61,18.6-2.77,4.2-3.67,8.45-2.53,11.97.86,2.64,2.82,4.71,5.39,5.67l-2.81,7.49c-4.86-1.82-8.57-5.72-10.19-10.69-1.91-5.88-.68-12.57,3.46-18.85,7.37-11.17,13.8-25.35,13.87-25.49l4.01-8.87,3.39,9.13c.05.14,5.16,13.78,12.66,23.81,4.21,5.62,5.63,13.98,3.55,20.8-1.53,5.02-4.82,8.63-9.26,10.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.12,
    y: 42.43,
    width: 8,
    height: 38.17
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSetzling);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/setzling.eb071263e05242d7d1d3ef27b30f2b34.svg";